import { create } from 'zustand';
import { BlogCategory, BlogCategoriesResponse } from '@/types';
import { fetchStrapiCollection } from '@/lib/strapi';

interface BlogCategoryState {
  categories: BlogCategory[];
  loading: boolean;
  error: string | null;
  hasFetched: boolean;
  fetchCategories: () => Promise<void>;
}

export const useBlogCategoryStore = create<BlogCategoryState>((set, get) => ({
  categories: [],
  loading: false,
  error: null,
  hasFetched: false,

  fetchCategories: async () => {
    if (get().loading) return;
    try {
      set({ loading: true, error: null });

      const categories = await fetchStrapiCollection<BlogCategoriesResponse['data'][number]>('blog-categories', {
        filters: { archived: { $ne: true } },
        sort: ['order:asc', 'name:asc'],
      });
      set({ categories, hasFetched: true, loading: false });
    } catch (error) {
      console.error('Error fetching blog categories:', error);
      set({ error: (error as Error).message, loading: false });
    }
  },
}));
